import { useState } from 'react';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur } from 'utils/form.utils';

export default function TradeTypeAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const options = [{ name: 'IMPORT' }, { name: 'EXPORT' }];

  const [selectedValue, setSelectedValue] = useState<{ name: string } | string>(
    formProps.field.value,
  );

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={selectedValue || formProps.field.value}
      multiple={false}
      error={error}
      loading={false}
      options={options}
      isOptionEqualToValue={(option, value) => value?.name === option?.name}
      getOptionLabel={(o) => (o?.name ? o.name : '')}
      handleSearchChange={() => {}}
      onChange={(_, data) => {
        if (data === null) {
          setSelectedValue('');
          formProps.field.onChange('');
        } else {
          setSelectedValue(data);
          formProps.field.onChange({ name: data.name });
        }
      }}
      onScrollBottom={() => {}}
      onBlur={createHandleOnBlur(
        () => {},
        setSelectedValue,
        formProps.field.onBlur,
      )}
    />
  );
}
